export const ACCOUNT_STOCK_EXCHANGE = Object.freeze({
  NASDAQ: 'NASDAQ',
  NYSE: 'NYSE',
});
